import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { TodoTemplate } from "~/models/TodoTemplate";

const paths = {
	index: "/todo_templates"
};

type TIndex = () => SwrReturnType<TodoTemplate[]>;
type ReturnType = {
	useIndex: TIndex;
};

export const useTodoTemplates = (): ReturnType => {
	const useIndex: TIndex = () => {
		const { data, mutate, error } = useSWR<TodoTemplate[]>(paths.index);
		return {
			data: data ?? null,
			error,
			isLoading: !data && !error,
			mutate: mutate ?? null
		};
	};
	return { useIndex };
};
